<template>
  <v-container fluid>
    <v-col cols="12">
      <v-row align="center" justify="center">
        <h1 v-text="this.noteName"></h1>
        <v-icon
          size="28"
          class="ml-2"
          color="grey lighten-1"
          @click="editWordNote()"
        >
          mdi-pencil-circle
        </v-icon>
      </v-row>
    </v-col>
    <v-col cols="12">
      <v-row align="center" justify="center">
        <v-list two-line subheader class="word-list">
          <v-subheader>単語一覧</v-subheader>
          <template v-if="words.length == 0 && isLoading == false">
            <div class="empty-area">
              <v-icon size="150" color="#cccccc"
                >mdi-format-list-bulleted</v-icon
              >
              <p>まだ単語が登録されていません。</p>
            </div>
          </template>
          <template v-else>
            <v-list-item
              three-line
              v-for="word in words"
              :key="word.id"
              @click="editWord(word)"
            >
              <v-list-item-avatar>
                <v-icon
                  v-if="word.data().done"
                  size="38"
                  color="secondary lighten-1"
                  >mdi-checkbox-marked-circle-outline</v-icon
                >
                <v-icon v-else size="38" color="grey lighten-1"
                  >mdi-checkbox-blank-circle-outline</v-icon
                >
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title
                  color="primary"
                  v-text="wordTitle(word.data())"
                ></v-list-item-title>
                <v-list-item-subtitle
                  v-text="wordTestResultTitle(word.data())"
                ></v-list-item-subtitle>
                <v-list-item-subtitle
                  v-text="wordDateTitle(word)"
                ></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn icon>
                  <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </template>

          <v-btn
            class="mt-4 word-add-button"
            height="60px"
            color="primary"
            dark
            @click="addWord"
          >
            単語を追加する
          </v-btn>

          <word-dialog
            v-model="dialog"
            v-bind:type="editType"
            v-bind:word="editingWord"
            v-on:saveClicked="saveWordClicked($event)"
            v-on:addClicked="addWordClicked($event)"
            v-on:close="closeDialog"
            v-on:deleteWord="deleteWord"
          ></word-dialog>
        </v-list>
      </v-row>
      <word-note-dialog
        v-model="editWordNoteDialog"
        type="edit"
        v-bind:word="editingWordName"
        v-on:saveClicked="editWordNoteClicked($event)"
        v-on:close="closeEditNoteDialog"
        v-on:deleteNote="deleteWordNote"
      ></word-note-dialog>
      <v-snackbar v-model="snackbar" :timeout="timeout">
        {{ errorMessage }}
        <template v-slot:action="{ attrs }">
          <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
            閉じる
          </v-btn>
        </template>
      </v-snackbar>
    </v-col>
  </v-container>
</template>

<script>
import { db, fb } from "../plugins/firebase.js";
import DatePicker from "@/components/DatePicker";
import WordNoteDialog from "@/components/WordNoteDialog";
import WordDialog from "@/components/WordDialog";
import { required, minValue, integer } from "vuelidate/lib/validators";
import { jpnDateFormat } from "../plugins/dateUtils.js";

export default {
  name: "UserWordNote",
  components: {
    DatePicker,
    WordNoteDialog,
    WordDialog,
  },
  methods: {
    async fetchWords(noteId) {
      const that = this;
      const noteSubscription = db
        .collection(`users/${this.uid}/word-notes`)
        .doc(noteId)
        .onSnapshot(function (doc) {
          that.note = doc.data();
          that.editingWordName = that.note.name;
        });

      const notesSubscription = db
        .collection(`users/${this.uid}/word-notes`)
        .doc(noteId)
        .collection("words")
        .orderBy("createdAt", "desc")
        .onSnapshot(function (querySnapshot) {
          that.isLoading = false;
          that.words = (querySnapshot.docs || []).map((doc) => {
            return doc;
          });
        });
      that.listeners.push(noteSubscription);
      that.listeners.push(notesSubscription);
    },
    editWord(word) {
      this.editType = "edit";
      this.editingWord = word.data();
      this.editingWord.createdAt = this.editingWord.createdAt
        .toDate()
        .toISOString()
        .substr(0, 10);
      this.editingWordId = word.id;
      this.dialog = true;
    },
    addWord() {
      this.editType = "add";
      this.resetWord();
      this.editingWord.createdAt = this.today;
      this.dialog = true;
    },
    wordDateTitle(word) {
      const date = word.data().createdAt.toDate();
      return jpnDateFormat(date);
    },
    wordTitle(word) {
      return `${word.english} (${word.japanese})`;
    },
    wordTestResultTitle(word) {
      return `正解数: ${word.correctCount}回 / 不正回数: ${word.wrongCount}回`;
    },
    closeDialog() {
      this.dialog = false;
    },
    closeEditNoteDialog() {
      this.editWordNoteDialog = false;
    },
    editWordNoteClicked(newWordNoteName) {
      const that = this;

      db.collection(`users/${this.uid}/word-notes`)
        .doc(this.noteId)
        .update({
          name: newWordNoteName,
          updatedAt: fb.firestore.FieldValue.serverTimestamp(),
        })
        .then(function () {
          that.closeEditNoteDialog();
        })
        .catch(function (error) {
          that.closeEditNoteDialog();
          that.errorMessage =
            "単語帳の更新に失敗しました。入力内容をご確認ください。";
          that.snackbar = true;
        });
    },
    addWordClicked(newWord) {
      this.dialog = false;
      const createdDate = new Date(newWord.createdAt);
      const that = this;

      db.collection(`users/${this.uid}/word-notes`)
        .doc(this.noteId)
        .collection("words")
        .add({
          japanese: newWord.japanese,
          english: newWord.english,
          correctCount: newWord.correctCount,
          wrongCount: newWord.wrongCount,
          done: newWord.done,
          wordType: newWord.wordType,
          updatedAt: fb.firestore.FieldValue.serverTimestamp(),
          createdAt: fb.firestore.Timestamp.fromDate(createdDate),
        })
        .then(function () {
          that.resetWord();
        })
        .catch(function (error) {
          that.errorMessage =
            "単語登録に失敗しました。入力内容をご確認ください。";
          that.snackbar = true;
        });
    },
    saveWordClicked(newWord) {
      this.dialog = false;
      const createdDate = new Date(newWord.createdAt);
      const that = this;

      db.collection(`users/${this.uid}/word-notes`)
        .doc(this.noteId)
        .collection("words")
        .doc(this.editingWordId)
        .update({
          japanese: newWord.japanese,
          english: newWord.english,
          correctCount: newWord.correctCount,
          wrongCount: newWord.wrongCount,
          done: newWord.done,
          wordType: newWord.wordType,
          updatedAt: fb.firestore.FieldValue.serverTimestamp(),
          createdAt: fb.firestore.Timestamp.fromDate(createdDate),
        })
        .then(function () {
          that.resetWord();
        })
        .catch(function (error) {
          that.errorMessage =
            "単語の更新に失敗しました。入力内容をご確認ください。";
          that.snackbar = true;
        });
    },
    resetWord() {
      this.editingWord.japanese = "";
      this.editingWord.english = "";
      this.editingWord.wrongCount = 0;
      this.editingWord.correctCount = 0;
      this.editingWord.wordType = "";
      this.editingWord.wordType = "名詞";
      this.editingWord.done = false;
    },
    deleteWord() {
      const that = this;
      db.collection(`users/${this.uid}/word-notes`)
        .doc(this.noteId)
        .collection("words")
        .doc(this.editingWordId)
        .delete()
        .then(function () {
          that.errorMessage = "単語を削除しました。";
          that.snackbar = true;
          that.closeDialog();
        })
        .catch(function (error) {
          that.errorMessage =
            "単語の削除に失敗しました。時間をおいて再度お試しください。";
          that.snackbar = true;
          that.closeDialog();
        });
    },
    deleteWordNote() {
      const that = this;
      db.collection(`users/${this.uid}/word-notes`)
        .doc(this.noteId)
        .delete()
        .then(function () {
          that.errorMessage = "単語帳を削除しました。";
          that.snackbar = true;
          that.closeEditNoteDialog();
          that.listeners.forEach(function (unsubscribe, index, array) {
            unsubscribe();
          });
          that.$router.push("user");
        })
        .catch(function (error) {
          that.errorMessage =
            "単語帳の削除に失敗しました。時間をおいて再度お試しください。";
          that.snackbar = true;
          that.closeEditNoteDialog();
        });
    },
    editWordNote() {
      this.editWordNoteDialog = true;
    },
  },
  data: () => ({
    isLoading: true,
    listeners: [],
    note: null,
    noteId: "",
    words: [],
    editType: "add",
    dialog: false,
    editWordNoteDialog: false,
    editingWordName: "",
    editingWord: {
      createdAt: "",
      japanese: "",
      english: "",
      correctCount: 0,
      wrongCount: 0,
      done: false,
      wordType: "",
    },
    today: new Date().toISOString().substr(0, 10),
    editingWordId: "",
    snackbar: false,
    errorMessage: "",
    timeout: 2000,
  }),
  computed: {
    noteName() {
      return this.note ? this.note.name : "";
    },
    uid() {
      return this.$store.getters.uid;
    },
  },
  async mounted() {
    let noteId = this.$store.getters.currentNoteId;
    this.noteId = noteId;
    this.fetchWords(noteId);
  },
};
</script>

<style scoped>
.word-list {
  width: 100%;
  max-width: 600px;
}
.empty-area {
  text-align: center;
  color: #aaaaaa;
}
.word-add-button {
  width: 100%;
}
</style>
